import { HStack, Text } from "@chakra-ui/react";

export default function Headline({
  title,
  icon,
}: {
  title: string;
  icon: React.ReactNode;
}) {
  return (
    <HStack gap={2} alignItems="center" justifyContent="flex-start" mb={2}>
      {icon}
      <Text
        fontSize="24px"
        fontWeight="600"
        textAlign="left"
        color="#1A202C"
        letterSpacing="-0.72px"
      >
        {title}
      </Text>
    </HStack>
  );
}
